import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from '@app/layout/service/app.layout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private primengConfig: PrimeNGConfig,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    // For more information check: https://primefaces.org/ultima-ng/#/documentation
    // Initial layout configuration can be defined at the main app component by injecting the LayoutService,
    // this step is optional and only necessary when customizing the defaults.

    this.primengConfig.ripple = true; //enables core ripple functionality

    // TODO prebaciti na primeng-locale kad upgrejdamo na Primeng v18+
    this.primengConfig.setTranslation({
      firstDayOfWeek: 1,
      dateFormat: 'dd/mm/yy',
      dayNames: [
        'Nedjelja',
        'Ponedjeljak',
        'Utorak',
        'Srijeda',
        'Četvrtak',
        'Petak',
        'Subota'
      ],
      dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
      dayNamesMin: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'],
      monthNames: [
        'Siječanj',
        'Veljača',
        'Ožujak',
        'Travanj',
        'Svibanj',
        'Lipanj',
        'Srpanj',
        'Kolovoz',
        'Rujan',
        'Listopad',
        'Studeni',
        'Prosinac'
      ],
      monthNamesShort: [
        'Sij',
        'Vel',
        'Ožu',
        'Tra',
        'Svi',
        'Lip',
        'Srp',
        'Kol',
        'Ruj',
        'Lis',
        'Stu',
        'Pro'
      ],
      today: 'Danas',
      clear: 'Očisti'
    });

    //optional configuration with the default configuration
    this.layoutService.config = {
      ripple: true, // toggles ripple on and off
      inputStyle: 'outlined', // default style for input elements
      menuMode: 'static', // layout mode of the menu, valid values are "static", "overlay", "slim", "horizontal" and "reveal"
      colorScheme: 'light', // color scheme of the template, valid values are "light" and "dark"
      componentTheme: 'teal', // default component theme for PrimeNG, not valid setting here
      scale: 14, // size of the body font size to scale the whole application, not valid setting here
      menuTheme: 'light', // theme of the menu
      topbarTheme: 'blue', // theme of the topbar, e.g. light
      menuProfilePosition: 'end' // position of the profile menu inside the main menu, valid values are "start" and "end"
    };
  }
}
